import Encoding from 'encoding-japanese'

export const readCSVFile = async file => {
  const isShiftJIS = await isFileShiftJIS(file)
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = resolve
    reader.onerror = reject
    reader.readAsText(file, isShiftJIS ? 'Shift_JIS' : 'utf8')
  }).then(result => result.target.result)
}

const isFileShiftJIS = file => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = resolve
    reader.onerror = reject
    reader.readAsArrayBuffer(file)
  })
    .then(result => result.target.result)
    .then(buf => {
      return Encoding.detect(largeBufferToString(buf)) === 'SJIS'
    })
}

const bufferToString = buf => String.fromCharCode.apply('', new Uint8Array(buf))

const largeBufferToString = buf => {
  var tmp = []
  var len = 1024
  for (var p = 0; p < buf.byteLength; p += len) {
    tmp.push(bufferToString(buf.slice(p, p + len)))
  }
  return tmp.join('')
}
